export function removeHTMLTags(text: string, allowedTags: string[] = []) {
  const allowedTagsArray = allowedTags.map((tag) => tag.toLowerCase());
  const htmlTagsRegExp = /<\/?([a-z0-9]*)\b[^>]*>/gi;

  return text.replace(htmlTagsRegExp, (tag, allowedTag: string) =>
    allowedTagsArray.includes(allowedTag.toLowerCase()) ? tag : "",
  );
}
